import {Directive} from './directive.interface';

export function bootstrapDirective(directive: Directive, entryElementsSelector?: string): void {
    if (entryElementsSelector) {
        const els = Array.from(document.querySelectorAll(entryElementsSelector)) as HTMLElement[];

        if (directive.bootstrapped) {
            directive.extendDom(els);
        } else {
            directive.injectDom(els);
        }
    }

    if (directive.bootstrapped) {
        return;
    }

    directive.bootstrapped = true;
    directive.init();
}